/*
 * History model:  Makes sure that history results get parsed to use i18n'ed strings for
 * the change type.
 */

define(["backbone", "underscore", "jquery"], function (Backbone, _, $) {
  var HistoryModel = {};

  HistoryModel.historyCollection = Backbone.Collection.extend({
    parse: function (response) {
      _.each(response, function (historyEntry) {
        switch (historyEntry.changeType) {
          case "Added Entry":
            historyEntry.changeType = $.t("history.addedEntry");
            break;
          case "Updated Entry":
            historyEntry.changeType = $.t("history.updatedEntry");
            break;
          case "Removed Entry":
            historyEntry.changeType = $.t("history.removedEntry");
            break;
          case "Added Example":
            historyEntry.changeType = $.t("history.addedExample");
            break;
          case "Updated Example":
            historyEntry.changeType = $.t("history.updatedExample");
            break;
          case "Moved Example":
            historyEntry.changeType = $.t("history.movedExample");
            break;
          case "Removed Example":
            historyEntry.changeType = $.t("history.removedExample");
            break;
          case "Disabled Auto Apply":
            historyEntry.changeType = $.t("history.disabledAutoApply");
            break;
          case "Enabled Auto Apply":
            historyEntry.changeType = $.t("history.enabledAutoApply");
            break;
        }
        //handle the final case of an updated content URL, which includes the touchpoint in the change type
        var contentUpdateEnding = " : Updated Entry";
        if (historyEntry.changeType.endsWith(contentUpdateEnding)) {
          var touchpoint = historyEntry.changeType.slice(0, -contentUpdateEnding.length);
          historyEntry.changeType = $.t("history.tpUpdatedEntry", { touchpoint: touchpoint });
        }
        //else don't change the type
      });
      return response;
    },
  });

  return HistoryModel;
});
